/* 证件审批申请相关接口 */
import { $post } from '@/api/request'
import base from '@/utils/index'
import axios from 'axios'

const baseFunc = base()
// 列表查询
export function query (data = {}) {
  return $post({
    url: '/compApplyPaper/query',
    data
  })
}
// 查询需要我审批的
export function queryMyAudit (data = {}) {
  return $post({
    url: '/compApplyPaper/queryMyAudit',
    data
  })
}

// 查询自己创建的
export function queryMine (data = {}) {
  return $post({
    url: '/compApplyPaper/queryMine',
    data
  })
}
// 查询自己创建的
export function listMineAndCanDownloaded (data = {}) {
  return $post({
    url: '/compApplyPaper/listMineAndCanDownloaded',
    data
  })
}
// 查询自己审批的
export function listApplyAudited (data = {}) {
  return $post({
    url: '/compApplyPaper/listApplyAudited',
    data
  })
}

// 新增
export function add (data = {}) {
  return $post({
    url: '/compApplyPaper/submitApply',
    data
  })
}

// 详情
export function getApplyDetail (data = {}) {
  return $post({
    url: '/compApplyPaper/getApplyDetail',
    data
  })
}

// 审批
export function audit (data = {}) {
  return $post({
    url: '/compApplyPaper/audit',
    data
  })
}
// 审批
export function auditAndNextUser (data = {}) {
  return $post({
    url: '/compApplyPaper/auditAndNextUser',
    data
  })
}
// 审批
export function stagingApply (data = {}) {
  return $post({
    url: '/compApplyPaper/stagingApply',
    data
  })
}
// 催批
export function sendSmsAuditPersonAgain (data = {}) {
  return $post({
    url: '/compApplyPaper/sendSmsAuditPersonAgain',
    data
  })
}

// 获取水印图片
export function postImageMark (data = {}) {
  let url = process.env.VUE_APP_BASE_API + '/minio/postImageMark'
  return new Promise((resolve, reject) => {
    axios(url, {
      method: 'post',
      data: data,
      responseType: 'blob',
      headers: {
        Authorization: baseFunc.getLocalStorage('token')
      }
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}
